import React from 'react';
import { ShieldCheckIcon, HeadphonesIcon, CreditCardIcon, RepeatIcon, BriefcaseIcon, TagIcon, RouteIcon, PhoneCallIcon } from 'lucide-react';
import { Section, SectionHeading } from '../ui/Section';
const items = [{
  icon: ShieldCheckIcon,
  title: 'Usados seleccionados',
  text: 'Cada unidad se revisa antes de publicarse.'
}, {
  icon: HeadphonesIcon,
  title: 'Atención personalizada',
  text: 'Un asesor asignado a tu operación.'
}, {
  icon: CreditCardIcon,
  title: 'Financiación disponible',
  text: 'Planes y cuotas según tu perfil.'
}, {
  icon: RepeatIcon,
  title: 'Tomamos permutas',
  text: 'Tu usado como parte de pago.'
}, {
  icon: BriefcaseIcon,
  title: 'Gestión de ventas particulares',
  text: 'Vendemos tu auto por vos.'
}, {
  icon: TagIcon,
  title: 'Oportunidades reales',
  text: 'Precios y condiciones publicados sin letra chica.'
}, {
  icon: RouteIcon,
  title: 'Acompañamiento total',
  text: 'Desde la consulta hasta la transferencia.'
}, {
  icon: PhoneCallIcon,
  title: 'Contacto directo',
  text: 'Hablás siempre con un vendedor real.'
}];
export function PorQueVcars() {
  return <Section id="por-que" data-id="element-336" data-mp="31bxe47fq739p">
      <SectionHeading title="¿Por qué elegir VCARS?" lead="Te acompañamos durante toda la operación, con información clara y respaldo comercial en cada paso." data-id="element-337" data-mp="31coy0kzynck5" />
      <ul className="grid gap-x-10 gap-y-1 sm:grid-cols-2 lg:grid-cols-4" data-id="element-338" data-mp="3b88tj6am498d">
        {items.map(({
        icon: Icon,
        title,
        text
      }) => <li key={title} className="flex gap-3.5 border-b border-line/60 py-5 last:border-b-0 sm:border-b" data-id="element-339" data-mp="3p701sc2sn0ol">
            <span className="mt-0.5 grid h-9 w-9 shrink-0 place-items-center rounded-lg bg-neon/12 text-neon" data-id="element-340" data-mp="2u076fyooeon">
              <Icon className="h-[18px] w-[18px]" aria-hidden="true" data-id="element-341" data-mp="3u0uhz5j6wxix" />
            </span>
            <div data-id="element-342" data-mp="btetr4bqc53v">
              <h3 className="text-[15px] font-bold text-white" data-id="element-343" data-mp="buyasx57mk6p">{title}</h3>
              <p className="mt-1 text-[13.5px] leading-relaxed text-mist" data-id="element-344" data-mp="6vlms92lr72j">{text}</p>
            </div>
          </li>)}
      </ul>
    </Section>;
}